import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=5f0d54ab"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"
import style0 from "./SidebarView.vue?vue&type=style&index=0&id=5f0d54ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports